/* eslint-disable react/prop-types */
import { Link, useNavigate, useLocation } from "react-router-dom";

const AffiliateFooter = ({ setOpen, open }) => {
  const nav = useNavigate();
  const { pathname } = useLocation();

  const isActive = (path) => pathname === path;

  return (
    <div className="mobileFooter flex lg:hidden">
      <div
        className={`footerMenu ${isActive("/affiliate") ? "active" : ""}`}
        onClick={() => nav("/affiliate")}
      >
        <img src="/dashboard.svg" alt="sports" />
        <span>Dashboard</span>
      </div>

      <div
        className={`footerMenu ${
          isActive("/affiliate/user-list") ? "active" : ""
        }`}
        onClick={() => nav("/affiliate/user-list")}
      >
        <img src="/user-list.svg" alt="inplay" />
        <span>User List</span>
      </div>

      <div className="footerMenu footerCasino">
        <Link
          to="#"
          className="affi-share-button"
          onClick={() => setOpen(!open)}
        >
          <img
            src="/affi-footer-share.png"
            alt="Casino"
            style={{ width: "100px" }}
          />
        </Link>
      </div>

      <div
        className={`footerMenu ${
          isActive("/affiliate/user-profit-loss") ? "active" : ""
        }`}
        onClick={() => nav("/affiliate/user-profit-loss")}
      >
        <img src="/graph.svg" alt="referral" />
        <span>Profit/Loss</span>
      </div>

      <div
        className={`footerMenu ${
          isActive("/affiliate/report") ? "active" : ""
        }`}
        onClick={() => nav("/affiliate/report")}
      >
        <img src="/report.png" alt="account" />
        <span>Report</span>
      </div>
    </div>
  );
};

export default AffiliateFooter;
